import {Component, OnInit, ViewChild} from '@angular/core';
import {EnquiryComponent} from './enquiry.component';
import {HeaderService} from '../header/header.service';

@Component({
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit{

    @ViewChild(EnquiryComponent) enquiryComponent : EnquiryComponent;

    ngOnInit(): void {
    }

    constructor(private headerService: HeaderService) {
        this.headerService.isHomepage(true);
        this.headerService.setLoginRegisterButtonsVisible();
    }

    showEnquiryComponent() {
        this.enquiryComponent.visible=true;
    }
}
